// extracted by mini-css-extract-plugin
module.exports = {"settingsContainer":"settings_settingsContainer__UUxyV","deleteButtonContainer":"settings_deleteButtonContainer__2_3k3","btn":"settings_btn__34UCQ"};